module.exports = __webpack_public_path__ + "img/hlziHead.0f03dc31.jpg";